export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export const stars = (score) => "★".repeat(score) + "☆".repeat(5 - score);

export const catLabel = (c) =>
  c === "defaulter"
    ? { hi: "डिफॉल्टर", en: "Defaulter", cls: "bg-red-100 text-red-700", dot: "bg-red-500" }
    : { hi: "नियमित", en: "Regular", cls: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500" };

export function apiError(e, fallback = "Kuch galat ho gaya") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
}
